import { transformCellValue } from './common.transformers'

export function transformAutoFill(
  valueObj,
  rowObj,
  templateField,
  templateFields,
  context,
  dataContainer,
  readOnlyTransform,
) {
  if (readOnlyTransform) return valueObj.cell_value

  let governanceOwner =
    templateField.field.segment_type === 'variable' ? templateField : templateField.field

  if (templateField.governance_type === 'link') {
    governanceOwner = templateField
  }

  const pullFromFieldId = governanceOwner.autofill?.field_id
  const pulledValueObj = rowObj[pullFromFieldId] || {}

  const rawValue = pulledValueObj.cell_value
  const cellValue = transformCellValue(rawValue, governanceOwner.transformation || {})
  return cellValue
}
